const coins = require('../coins');
const REFERENCE_ASSETS = require('../reference-assets.js');

module.exports = [{
    dataIndex: 0,
    id: 'factory-v2-0',
    name: 'factory-v2-0',
    lpTokenInfo: {
        name: '3poolCurve',
        symbol: '3poolCrv',
    },
    assets: 'DAI+USDC+USDT',
    coins: [
        coins.dai,
        coins.usdc,
        coins.usdt,
    ],
    addresses: {
        swap: '0x998395fEd908d33CF27115A1D9Ab6555def6cd45',
        lpToken: '0x998395fEd908d33CF27115A1D9Ab6555def6cd45',
        gauge: '0x998395fEd908d33CF27115A1D9Ab6555def6cd45',
    },
    hasNoGauge: true,
    isFactoryOnlyPool: true,
    factoryVersion: 2,
    // gaugeVersion: 3, // No CRV rewards
    hasNoCRVRewards: true,
}];
